/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestMetricTargetClone } from '../../models/harvest-metric-target-clone';
import { HarvestMetricTargetDto } from '../../models/harvest-metric-target-dto';

export interface CloneTargets$Params {
      body: HarvestMetricTargetClone
}

export function cloneTargets(http: HttpClient, rootUrl: string, params: CloneTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetDto>> {
  const rb = new RequestBuilder(rootUrl, cloneTargets.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestMetricTargetDto>;
    })
  );
}

cloneTargets.PATH = '/api/metric-target/clone';
